<script>
  import NavigationHeader from '../NavigationHeader.vue';
  import InvoicesService from '@/services/InvoicesService';

  export default {
    name: 'Invoices',
    components: {
      NavigationHeader,
    },
    data() {
      return {
        invoices: [],
      };
    },
    created() {
        InvoicesService.getInvoices().then((response) => {
          this.invoices = response.data;
        });
    },
    methods: {},
  };
</script>

<template>
    <div class="container">
        <div class="invoices">
            <NavigationHeader route="/" navigationText="zurück zum Dashboard" title="Rechnungen"/>
            <p>
                Hier kannst Du deine Rechungen im PDF-Format herunterladen. Einzelverbindungsnachweise zur Rechnungen
                sind zusätzlich im Excel-Format erhältlich.
            </p>
            <div class="wrapper">
                <div class="invoice" v-for="invoice in invoices" v-if="invoice" :key="invoice.id">
                    <div class="date">{{ invoice.date }}</div>
                    <div class="number">{{ invoice.invoice_number }}</div>
                    <div class="amount">{{ invoice.amount + ' ' + invoice.cur }}</div>
                    <div class="download">
                        <a :href="invoice.download_pdf" class="download_link">
                            <img src="@/assets/starface_icons_png/16/orange/download_16.png" alt="Download"/> Rechnung
                        </a>
                        <a :href="invoice.download_cdr" class="download_link">
                            <img src="@/assets/starface_icons_png/16/orange/download_16.png" alt="Download"/>
                            Einzelverbindungsnachweis
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import '../../assets/scss/variables.scss';

    .wrapper {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        margin-top: 60px;
        padding-top: 10px;
    }

    .invoice {
        height: 208px;
        width: 305.7px;
        background-color: #FFFFFF;
        box-shadow: 0 10px 45px 0 rgba(0, 0, 0, 0.1);
        margin-bottom: 25px;
        padding: 20px 0 20px 20px;
        &:nth-child(3n-1) {
            margin: 0 29.5px 0 29px;
        }
    }

    .date {
        height: 38px;
        width: 154.58px;
        color: $grey-dark;
        font-size: 28px;
        line-height: 38px;
    }

    .number {
        height: 24px;
        width: 107.02px;
        color: $grey-middle;
        font-size: 18px;
        line-height: 24px;
    }

    .amount {
        height: 32px;
        min-width: 130px;
        padding: 4px 15px;
        margin: 15px 0;
        background-color: $grey-dark;
        color: #FFFFFF;
        font-size: 18px;
        font-weight: bold;
        line-height: 24px;
        text-align: right;
        float: right;
        display: block;
    }

    .download {
        clear: both;
        a {
            display: block;
            color: $orange;
            font-size: 16px;
            line-height: 22px;
            margin-bottom: 5px;
            img {
                margin-right: 10px;
                position: relative;
                top: 2px;
            }
        }
    }
</style>